function checkFilterMatch(optionStr, filter) {
    const o = optionStr ? optionStr.toLocaleLowerCase() : '';
    const f = filter.toLocaleLowerCase();

    return o.includes(f);
}

import { getOrganisations } from "./api.js";
import { debouncePromise } from "./debouncePromise.js";

export class ComboboxDataProvider {
    constructor(currentCustomerId) {
        /** @type {Object[]} */
        this.options = [];

        /** @type number */
        this.currentCustomerId = currentCustomerId;
    }

    setOptions(items) {
        this.options = items;
    }

    getOptions = debouncePromise(async (searchText) => {
        if (searchText) {
            this.options = (await getOrganisations(searchText))
                .EntityArray
                .filter(org => org.CustomerId !== this.currentCustomerId)
                .map(org => ({
                    label: org.IsSite ? org.SiteName : org.SchoolName,
                    value: org.CustomerId
                }));
            return this.options.filter(e => checkFilterMatch(e.label, searchText));
        } else {
            this.options = [];
        }

        return this.options;
    }, 500);

    getNameById(id) {
        const resultItem = this.options.find(e => e.value === id);

        return resultItem ? resultItem.label : undefined;
    }
}
